import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5087394c")

_pushScopeId("data-v-5087394c")
const _hoisted_1 = { class: "line-pool" }
const _hoisted_2 = { class: "category-name" }
const _hoisted_3 = { class: "line-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LinePointMarker = _resolveComponent("LinePointMarker")
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.lineList, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "category",
        key: item.type
      }, [
        _createVNode("div", _hoisted_2, _toDisplayString(item.type), 1),
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children, (line, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "line-item",
              key: index
            }, [
              _createVNode("div", {
                class: "line-content",
                onClick: ($event: any) => (_ctx.selectLine(line))
              }, [
                _createVNode(_component_SvgWrapper, {
                  overflow: "visible",
                  width: "20",
                  height: "20"
                }, {
                  default: _withId(() => [
                    _createVNode("defs", null, [
                      (line.points[0])
                        ? (_openBlock(), _createBlock(_component_LinePointMarker, {
                            key: 0,
                            class: "line-marker",
                            id: `preset-line-${index}`,
                            position: "start",
                            type: line.points[0],
                            color: "currentColor",
                            baseSize: 2
                          }, null, 8, ["id", "type"]))
                        : _createCommentVNode("", true),
                      (line.points[1])
                        ? (_openBlock(), _createBlock(_component_LinePointMarker, {
                            key: 1,
                            class: "line-marker",
                            id: `preset-line-${index}`,
                            position: "end",
                            type: line.points[1],
                            color: "currentColor",
                            baseSize: 2
                          }, null, 8, ["id", "type"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("path", {
                      class: "line-path",
                      d: line.path,
                      stroke: "currentColor",
                      fill: "none",
                      "stroke-width": "2",
                      "stroke-dasharray": line.style === 'solid' ? '0, 0' : '4, 1',
                      "stroke-linecap": "",
                      "stroke-linejoin": "",
                      "stroke-miterlimit": "",
                      "marker-start": line.points[0] ? `url(#${`preset-line-${index}`}-${line.points[0]}-start)` : '',
                      "marker-end": line.points[1] ? `url(#${`preset-line-${index}`}-${line.points[1]}-end)` : ''
                    }, null, 8, ["d", "stroke-dasharray", "marker-start", "marker-end"])
                  ]),
                  _: 2
                }, 1024)
              ], 8, ["onClick"])
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
})